
import { groupsCollapsedFacet, allGroupsCollapsedFacet } from '../facets/ScopeFacets';
import { IGroup } from 'office-ui-fabric-react/lib/DetailsList';
import { createAsyncActionCreator, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { resolveItems } from './getItems';

/**
 * @public
 */
export interface IToggleCollapseAllPayload {
  itemsScopeItemKey: string;
  newAllCollapsed: boolean;
  groups: IGroup[];
}

export const toggleCollapseAll: IAsyncActionCreator<IToggleCollapseAllPayload, IItemCacheThunkAction<void>> = createAsyncActionCreator((
  payload: IToggleCollapseAllPayload): IItemCacheThunkAction<void> => {
  let {
    itemsScopeItemKey,
    newAllCollapsed,
    groups
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    let groupsCollapsed: typeof groupsCollapsedFacet.type = {};
    for (let group of groups) {
      if (group.key.indexOf('groupPage-') === -1) {
        groupsCollapsed[group.key] = newAllCollapsed;
      }
      if (group.children) {
        for (let child of group.children) {
          groupsCollapsed[child.key] = newAllCollapsed;
        }
      }
    }

    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: {
          ...groupsCollapsedFacet.pack(groupsCollapsed),
          ...allGroupsCollapsedFacet.pack(newAllCollapsed)
        }
      }
    }));
  };
});
